/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum PaymentMethod {
  // Pay with credit card.
  CreditCard = 'btg::payment-method::credit-card',
  // Pay with bank account.
  BankAccount = 'btg::payment-method::bank-account',
  // Pay with PCHome Pay.
  PCHomePay = 'btg::payment-method::pchome-pay',
  // Pay with CVS barcode.
  CVSBarcodeTW = 'btg::payment-method::tw::cvs-barcode',
  // Pay with WebATM.
  WebATMTW = 'btg::payment-method::tw::web-atm',
}
